import type { JSX } from 'react';
import type { SurfaceOf } from './types';

export function ErrorSurfaceView({ surface }: { surface: SurfaceOf<'error'> }): JSX.Element {
  return (
    <section className={surface.recoverable ? 'surface surface-error' : 'surface surface-error fatal'} role="alert">
      <strong>{surface.code}</strong>
      <p>{surface.message}</p>
    </section>
  );
}
